import create from 'zustand'

interface IAutoSuggestionsStore {
  options: Record<string, string[]>;
  setOptions: (k: string, options: string[]) => void;
  setOptionsBatch: (o: Record<string, string[]>) => void;
}

export const useAutoSuggestionsStore = create<IAutoSuggestionsStore>((set) => ({
  options: {},
  setOptions: (k: string, options: string[]) => set(x => ({ ...x, options: { ...(x.options || {}), [k]: options } })),
  setOptionsBatch: (o: Record<string, string[]>) => set(x => ({ ...x, options: { ...(x.options || {}), ...o } })),
}));

export const useSetAutoSuggestionsOptions = () => useAutoSuggestionsStore(x => x.setOptions);
